<div class="header-wrapper">
  <star-core-notice-banner></star-core-notice-banner>

  <nav class="header fixed left-0 right-0 hidden lg:block">
    <div class="screen-max-size padding-until-widescreen">
      <div class="header-menu">
        <ul class="my-0 list-none items-center lg:flex lg:h-[61px]">
          <li>
            <a [routerLink]="'/'" class="focus-link">
              <img
                alt=""
                class="lg:w-[200px]"
                [src]="
                  'logo-star_alliance.svg' | rdAssetPath: AssetType.Image
                " />
            </a>
          </li>
          <li class="ml-6 mr-auto">
            <a
              routerLink="/transfer/programs"
              class="header-link-text typo-small-text-desktop focus-link"
              [innerHTML]="'wl.star.header.use_points' | translate"></a>
          </li>
          <ng-container [ngSwitch]="getComponentRenderState()">
            <ng-container *ngSwitchCase="'loggedOut'">
              <li class="mr-4 w-[150px]">
                <rd-shared-button
                  class="desktop-header-button login-button"
                  (clickFn)="handleUserAction('login')"
                  [buttonClass]="'login-button'"
                  [buttonContent]="loginButtonContent"
                  [buttonTheme]="'primary'">
                  <ng-template #loginButtonContent>
                    <div class="button-content">
                      <span>{{ 'wl.star.header.log_in' | translate }}</span>
                    </div>
                  </ng-template>
                </rd-shared-button>
              </li>
              <li class="w-[150px]">
                <rd-shared-button
                  class="desktop-header-button enroll-button"
                  (clickFn)="handleUserAction('enroll')"
                  [buttonClass]="'login-button'"
                  [buttonContent]="enrollButtonContent"
                  [buttonTheme]="'outline-primary'">
                  <ng-template #enrollButtonContent>
                    <div class="button-content">
                      <span>{{ 'wl.star.header.enroll_now' | translate }}</span>
                    </div>
                  </ng-template>
                </rd-shared-button>
              </li>
            </ng-container>
            <ng-container *ngSwitchCase="'loggedIn'">
              <star-core-header-profile
                (userActionEvent)="
                  handleUserAction($event)
                "></star-core-header-profile>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
  </nav>

  <star-mobile-header [authRenderState]="authRenderState"> </star-mobile-header>
</div>
